function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import __ from 'ramda/src/__';
import { CurrentCustomerSelector, CurrentCustomerIdSelector, SelectedCustomerActiveProductsSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CombinedEntitlementTypesSelector, ConvergentBillerAccountDetailsSelector, IsFetchingAccountDetailsSelector, IsFetchingSubscriberSummarySelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import localeKeys from '../../../../../locales/keys';
import { HasSuspendResumePermissionSelector, ResumeServiceReasonCodesSelector, SuspendServiceReasonCodesSelector } from '../../../../../reducers/selectors/services.selectors';
var ServicesController = /*#__PURE__*/function () {
  function ServicesController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ServicesController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      localeKeys: localeKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.RegularExpression, CODES.ReasonCodes, CODES.ServiceAttribute, CODES.UnitsOfMeasure];
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        stateGo: stateGo
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          accountDetails: ConvergentBillerAccountDetailsSelector(store),
          combinedEntitlementTypes: CombinedEntitlementTypesSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          customerActiveProductsSelector: SelectedCustomerActiveProductsSelector(store),
          hasSuspendResumeAccess: HasSuspendResumePermissionSelector(store),
          isCodeTableLoaded: MetadataCodeLoadedSelector(__, store),
          isFetchingAccountDetails: IsFetchingAccountDetailsSelector(store),
          isFetchingAccountSummary: IsFetchingSubscriberSummarySelector(store),
          isServiceReasonCodeLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          isUnitsOfMeasureLoaded: MetadataCodeLoadedSelector(CODES.UnitsOfMeasure, store),
          resumeServiceReasonCodes: ResumeServiceReasonCodesSelector(store),
          suspendServiceReasonCodes: SuspendServiceReasonCodesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (code) {
        if (!_this.state.isCodeTableLoaded(code)) {
          _this.actions.fetchCodeTypesThunk(code).catch(_this.onApiError);
        }
      });
    }
  }, {
    key: "onApiError",
    value: function onApiError(error) {
      this.uiNotificationService.transientError(error.translatedMessage);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "onRefreshServices",
    value: function onRefreshServices() {
      this.refreshServices && this.refreshServices();
    }
  }]);
}();
export default {
  template: require('./services.deprecated.html'),
  bindings: {
    hasAdminAccess: '<',
    refreshServices: '&?'
  },
  controller: ServicesController,
  controllerAs: 'Services'
};